import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800 p-6">
      <h1 className="text-9xl font-bold">404</h1>
      <h2 className="text-3xl font-semibold mt-4">Page Not Found</h2>
      <p className="text-lg mt-2 text-center">
        Sorry, the page you are looking for does not exist. It might have been moved or deleted.
      </p>
      <button
        onClick={goHome}
        className="mt-6 px-4 py-2 bg-blue-600 text-white text-lg rounded hover:bg-blue-700 transition duration-300"
      >
        Go to Home
      </button>
    </div>
  );
};

export default ErrorPage;
